import React, { useEffect, useRef } from "react";

import { css } from "@emotion/react";

type BlurProps = {
  children: React.ReactNode;
  blurAmount?: number;
};

export const Blur = ({ children, blurAmount = 5 }: BlurProps) => {
  const style = css({
    filter: `blur(${blurAmount}px)`,
    pointerEvents: "none", // disable mouse events
  });
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    // make sure we cannot tab through blurred content
    ref.current
      ?.querySelectorAll("a, button, input, textarea, select")
      .forEach((el) => {
        if (el instanceof HTMLElement) el.tabIndex = -1;
      });
  }, []);

  return (
    <div ref={ref} css={style}>
      {children}
    </div>
  );
};
